import { namespace } from '../../runtime'
import en from './en'

/** Words both apps share: the sport-independent glossary. */
export const sharedMessages = namespace('shared', en, {
  fr: () => import('./fr'),
  es: () => import('./es'),
})
